import { defineStore } from "pinia"
import type { Contact } from "@/model/DataModel"
import { UseRootStore } from "@/model/RootStore"
import type { View } from "@/types"
import * as apiClient from "@/utils/ApiClient"

type FetchByViewOptions = {
	limit: number
	offset: number
}

export const useBuyerStore = defineStore("buyer", () => {
	const rootStore = UseRootStore()

	async function fetchByView(view: View, options: FetchByViewOptions): Promise<{ items: Contact[]; total: number }> {
		return await apiClient.searchBuyersByView(rootStore.userApiToken, view, options.limit, options.offset)
	}

	return {
		fetchByView,
	}
})
